import React from 'react'

import * as styled from './styles'

const Option = ({ children, ...rest }) => (
  <styled.Option {...rest}>{children}</styled.Option>
)

export default Option
